import type { IconAsset } from '../Icon.types';

export const chevronUp: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M12 6.12132L20.5754 14.6967L18.454 16.818L12 10.364L5.54594 16.818L3.42462 14.6967L12 6.12132Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M9.99999 4.87868L17.0607 11.9393L14.9393 14.0607L9.99999 9.12132L5.06065 14.0607L2.93933 11.9393L9.99999 4.87868Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <g
          fill='none'
          transform='translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) '
        >
          <polygon points='0 0 16 0 16 16 0 16' />
          <polygon
            fill='currentColor'
            points='6.41 2 5 3.41 9.58 8 5 12.59 6.41 14 12.41 8'
          />
        </g>
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M12 6.82843L20.2218 15.0502L18.8076 16.4645L12 9.65686L5.19241 16.4645L3.7782 15.0502L12 6.82843Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M10 5.58578L16.7071 12.2929L15.2929 13.7071L10 8.41421L4.70712 13.7071L3.29291 12.2929L10 5.58578Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M8.00001 4.58578L12.7071 9.29289L11.2929 10.7071L8.00001 7.41421L4.70712 10.7071L3.29291 9.29289L8.00001 4.58578Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
